import React from "react";
import {Outlet} from "react-router-dom";
import Menu from "routes/Menu";

const Reports = () => {
  Menu(4);
  return (
    <>
      <Outlet />
    </>
  );
};

export default Reports;
